var isDesktopSm = function () {
    return window.innerWidth >= ICF.Variables.Breakpoints.DesktopSm && window.innerWidth < ICF.Variables.Breakpoints.Desktop;
};

module.exports = isDesktopSm;